import React, { useState } from 'react';
import Checkbox from "../../Checkbox/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { filterUsersAction } from "../../../redux/rootReducer";
import { getUsersThunk } from "../../../redux/thunks/getUsersThunk";
import { FILTER_USERS_INITIAL } from "../../../redux/initialStateConstant";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";

const UsersFilter = () => {
    const dispatch = useDispatch();

    const filterUsers = useSelector(state => state.filterUsers);

    // Состояние календаря
    const [openExpireCalendar, setOpenExpireCalendar] = useState(false);
    const [openRegistrationCalendar, setOpenRegistrationCalendar] = useState(false);
    const [openBirthdayFromCalendar, setOpenBirthdayFromCalendar] = useState(false);
    const [openBirthdayToCalendar, setOpenBirthdayToCalendar] = useState(false);
    const [calendar, setCalendar] = useState(null);

    return (
        <div className="flt__content">
            <div className="flt__reset" onClick={ () => dispatch(filterUsersAction(FILTER_USERS_INITIAL)) }>Сбросить фильтры</div>
            <div className="flt__caption">Фильтры</div>
            {/*<div className="flt__box">*/}
            {/*    <Checkbox*/}
            {/*        active={ filterUsers.without_subscriptions === '1'  }*/}
            {/*        caption={ 'Нет действующих абонементов' }*/}
            {/*        handler={ () => dispatch(filterUsersAction({*/}
            {/*            ...filterUsers,*/}
            {/*            without_subscriptions: filterUsers.without_subscriptions === '1' ? '0' : '1'*/}
            {/*        })) }*/}
            {/*    />*/}
            {/*</div>*/}
            {/*<div className="flt__box">*/}
            {/*    <div className="flt__title">Абонементы заканчиваются до</div>*/}
            {/*    <div*/}
            {/*        className="input input--datepicker"*/}
            {/*        onClick={ event => {*/}
            {/*            event.preventDefault();*/}
            {/*            event.stopPropagation();*/}
            {/*            setOpenExpireCalendar(!openExpireCalendar);*/}
            {/*        } }*/}
            {/*    >{ filterUsers.expire_to ? new Date(filterUsers.expire_to).toLocaleDateString('ru-Ru') : '' }</div>*/}
            {/*    <CalendarOffline*/}
            {/*        date={ filterUsers.expire_to }*/}
            {/*        handler={ date => {*/}
            {/*            dispatch(filterUsersAction({*/}
            {/*                ...filterUsers,*/}
            {/*                expire_to: date*/}
            {/*            }));*/}
            {/*            setOpenExpireCalendar(false);*/}
            {/*        }}*/}
            {/*        open={ openExpireCalendar }*/}
            {/*        close={ () => setOpenExpireCalendar(false) }*/}
            {/*    />*/}
            {/*</div>*/}
            <div className="flt__box">
                <div className="flt__title">Зарегистрировался не позднее</div>
                <div
                    className="input input--datepicker input--filter"
                    onClick={ event => {
                        event.preventDefault();
                        event.stopPropagation();
                        setOpenRegistrationCalendar(!openRegistrationCalendar);
                    } }
                >{ filterUsers.registration_not_later ? new Date(filterUsers.registration_not_later).toLocaleDateString('ru-Ru') : '' }</div>
                <CalendarOffline
                    date={ filterUsers.registration_not_later }
                    handler={ date => {
                        dispatch(filterUsersAction({
                            ...filterUsers,
                            registration_not_later: date
                        }));
                        setOpenRegistrationCalendar(false);
                    }}
                    open={ openRegistrationCalendar }
                    close={ () => setOpenRegistrationCalendar(false) }
                />
            </div>
            {/*<div className="flt__box">*/}
            {/*    <div className="flt__title">Осталось тренировок менее</div>*/}
            {/*    <input type="number" className="input input--filter"*/}
            {/*           value={ filterUsers.workouts_less_than }*/}
            {/*           onInput={ event => dispatch(filterUsersAction({*/}
            {/*               ...filterUsers,*/}
            {/*               workouts_less_than: event.target.value*/}
            {/*           })) }*/}
            {/*    />*/}
            {/*</div>*/}
            <div className="flt__box">
                <div className="flt__title">Не был Х дней (укажите число)</div>
                <input type="number" className="input input--filter"
                       value={ filterUsers.not_been_x_months }
                       onInput={ event => dispatch(filterUsersAction({
                           ...filterUsers,
                           not_been_x_months: event.target.value
                       })) }
                />
            </div>
            <div className="flt__box">
                <div className="flt__title">Период последней тренировки</div>
                <div className="flt__flex">
                    <div className="input input--datepicker input--filter"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setCalendar(calendar === 'last_workout_from' ? null : 'last_workout_from');
                         } }
                    >{ filterUsers.last_workout_from ? new Date(filterUsers.last_workout_from).toLocaleDateString('ru-Ru') : 'с' }</div>
                    <div className="input input--datepicker input--filter"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setCalendar(calendar === 'last_workout_to' ? null : 'last_workout_to');
                         } }
                    >{ filterUsers.last_workout_to ? new Date(filterUsers.last_workout_to).toLocaleDateString('ru-Ru') : 'по' }</div>
                </div>
                <CalendarOffline
                    date={ filterUsers[calendar] ? filterUsers[calendar] : '' }
                    handler={ date => {
                        dispatch(filterUsersAction({
                            ...filterUsers,
                            [calendar]: date
                        }));
                        setCalendar(null);
                    }}
                    open={ calendar === 'last_workout_from' || calendar === 'last_workout_to' }
                    close={ () => setCalendar(null) }
                />
            </div>
            <div className="flt__box">
                <div className="flt__title">Количество тренировок менее или равно</div>
                <input type="number" className="input input--filter"
                       value={ filterUsers.workouts_count }
                       onInput={ event => dispatch(filterUsersAction({
                           ...filterUsers,
                           workouts_count: event.target.value
                       })) }
                />
            </div>
            <div className="flt__box">
                <div className="flt__title">День рождения с</div>
                <div
                    className="input input--datepicker input--filter"
                    onClick={ event => {
                        event.preventDefault();
                        event.stopPropagation();
                        setOpenBirthdayFromCalendar(!openBirthdayFromCalendar);
                    } }
                >{ filterUsers.birthday_from ? new Date(filterUsers.birthday_from).toLocaleDateString('ru-Ru') : '' }</div>
                <CalendarOffline
                    date={ filterUsers.birthday_from }
                    handler={ date => {
                        dispatch(filterUsersAction({
                            ...filterUsers,
                            birthday_from: date
                        }));
                        setOpenBirthdayFromCalendar(false);
                    }}
                    open={ openBirthdayFromCalendar }
                    close={ () => setOpenBirthdayFromCalendar(false) }
                />
            </div>
            <div className="flt__box">
                <div className="flt__title">День рождения по</div>
                <div
                    className="input input--datepicker input--filter"
                    onClick={ event => {
                        event.preventDefault();
                        event.stopPropagation();
                        setOpenBirthdayToCalendar(!openBirthdayToCalendar);
                    } }
                >{ filterUsers.birthday_to ? new Date(filterUsers.birthday_to).toLocaleDateString('ru-Ru') : '' }</div>
                <CalendarOffline
                    date={ filterUsers.birthday_to }
                    handler={ date => {
                        dispatch(filterUsersAction({
                            ...filterUsers,
                            birthday_to: date
                        }));
                        setOpenBirthdayToCalendar(false);
                    }}
                    open={ openBirthdayToCalendar }
                    close={ () => setOpenBirthdayToCalendar(false) }
                />
            </div>
            <div className="flt__box">
                <Checkbox
                    active={ filterUsers.without_workouts === '1'  }
                    caption={ 'Новый посетитель' }
                    handler={ () => dispatch(filterUsersAction({
                        ...filterUsers,
                        without_workouts: filterUsers.without_workouts === '1' ? '0' : '1'
                    })) }
                />
            </div>
            <div className="flt__box">
                <Checkbox
                    active={ filterUsers.debt === '1'  }
                    caption={ 'Должники' }
                    handler={ () => dispatch(filterUsersAction({
                        ...filterUsers,
                        debt: filterUsers.debt === '1' ? '0' : '1'
                    })) }
                />
            </div>
            <div className="flt__box">
                <Checkbox
                    active={ filterUsers.admin === '1'  }
                    caption={ 'Администраторы' }
                    handler={ () => dispatch(filterUsersAction({
                        ...filterUsers,
                        admin: filterUsers.admin === '1' ? '0' : '1'
                    })) }
                />
            </div>
            <div className="flt__box">
                <Checkbox
                    active={ filterUsers.coach === '1'  }
                    caption={ 'Тренеры' }
                    handler={ () => dispatch(filterUsersAction({
                        ...filterUsers,
                        coach: filterUsers.coach === '1' ? '0' : '1'
                    })) }
                />
            </div>
            <div
                className="button button--blue"
                onClick={ () => {
                    dispatch(getUsersThunk({
                        page: 1,
                        without_subscriptions: filterUsers.without_subscriptions,
                        expire_to: filterUsers.expire_to,
                        workouts_less_than: filterUsers.workouts_less_than,
                        registration_not_later: filterUsers.registration_not_later,
                        not_been_x_months: filterUsers.not_been_x_months,
                        last_workout_from: filterUsers.last_workout_from,
                        last_workout_to: filterUsers.last_workout_to,
                        birthday_from: filterUsers.birthday_from,
                        birthday_to: filterUsers.birthday_to,
                        admin: filterUsers.admin,
                        coach: filterUsers.coach,
                        workouts_count: filterUsers.workouts_count,
                        debt: filterUsers.debt,
                        without_workouts: filterUsers.without_workouts
                    }));
                } }
            >Применить</div>
        </div>
    );
};

export default UsersFilter;